export interface KycRedirectOptions {
  next?: string
}

export function buildKycRedirectUrl(options: KycRedirectOptions = {}): string {
  const next = options.next && options.next.trim() !== "" ? options.next : "/"
  const encodedNext = encodeURIComponent(next)
  return `/kyc?next=${encodedNext}`
}

export function buildKycRedirectState() {
  return { forceRedirect: true, forceKyc: true } as const
}

export function buildKycRedirect(options: KycRedirectOptions = {}) {
  return {
    url: buildKycRedirectUrl(options),
    state: buildKycRedirectState(),
  }
}
